import HoSoBenhAn from './ho-so-benh-an';
import PhieuXetNghiem from './phieu-xet-nghiem';
import PhieuChanDoanHinhAnh from './phieu-chan-doan-hinh-anh';
import PhieuChuyenKhoa from './phieu-chuyen-khoa';
import PhieuThuoc from './phieu-thuoc';
import PhieuVatTu from './phieu-vat-tu';
import PhieuDichVuKhac from './phieu-dich-vu-khac';
import GiayNghiOm from './giay-nghi-om';

import {LOAI_BENH_AN} from "src/app/modules/phan-he-kham-benh/constants/BenhAn";
import PhieuKhamBenh from "./phieu-kham-benh";

export const ComponentMapper: Record<string, any> = {
	[LOAI_BENH_AN.THONG_TIN_BENH_AN.HO_SO_BENH_AN]: HoSoBenhAn,
	[LOAI_BENH_AN.THONG_TIN_BENH_AN.GIAY_NGHI_OM]: GiayNghiOm,
	[LOAI_BENH_AN.PHIEU_CHUYEN_KHOA]: PhieuChuyenKhoa,
  [LOAI_BENH_AN.PHIEU_KHAM_BENH]: PhieuKhamBenh,
  [LOAI_BENH_AN.PHIEU_XET_NGHIEM]: PhieuXetNghiem,
  [LOAI_BENH_AN.PHIEU_CHAN_DOAN_HINH_ANH]: PhieuChanDoanHinhAnh,
  [LOAI_BENH_AN.PHIEU_CHUYEN_KHOA]: PhieuChuyenKhoa,
  [LOAI_BENH_AN.DICH_VU_KHAC]: PhieuDichVuKhac,
  [LOAI_BENH_AN.DON_THUOC]: PhieuThuoc,
  [LOAI_BENH_AN.VAT_TU]: PhieuVatTu,

	DEFAULT: <></>,
};

export const ComponentTypeListMapper: Record<string, any> = {
	[LOAI_BENH_AN.PHIEU_KHAM_BENH]: PhieuKhamBenh,
	[LOAI_BENH_AN.PHIEU_XET_NGHIEM]: PhieuXetNghiem,
	[LOAI_BENH_AN.PHIEU_CHAN_DOAN_HINH_ANH]: PhieuChanDoanHinhAnh,
	[LOAI_BENH_AN.PHIEU_CHUYEN_KHOA]: PhieuChuyenKhoa,
	[LOAI_BENH_AN.DICH_VU_KHAC]: PhieuDichVuKhac,
	[LOAI_BENH_AN.DON_THUOC]: PhieuThuoc,
	[LOAI_BENH_AN.VAT_TU]: PhieuVatTu,

	DEFAULT: <></>,
};
